// Static content for Helios Cleantech site

export const CONTACT = {
  company: "Helios Cleantech Pvt. Ltd.",
  gst: "24AAGCH3472A1Z1",
  founded: "2022",
  email: "helioscleantechpvtltd@gmail.com",
  whatsapp: "https://wa.me/919998147181",
  iotDashboard: "http://119.45.122.38/index/user/login.html?&lang=en-us",
  address:
    "Plot No. 2/1/B Industrial Shed Near Ishwar Oil Mill, B/h Sopan Traders, Opp. Thakar Dhani Hotel, Kalawad Road, Chhapara, Rajkot-360021, Gujarat, India.",
  people: [
    { name: "Darshan Pambhar", phone: "+91 99981 47181", tel: "+919998147181" },
    { name: "Kirtan Patel", phone: "+91 72111 50088", tel: "+917211150088" },
  ],
  social: {
    instagram: "https://www.instagram.com/helios_cleantech/",
    facebook: "https://www.facebook.com/helioscleantech/",
    linkedin: "https://www.linkedin.com/company/helios-cleantech-pvt-ltd/",
    x: "https://x.com/helioscleantech",
    indiamart: "https://www.indiamart.com/helioscleantech/profile.html",
    catalog: "https://www.solarpanelcleaningrobot.co.in/",
  },
};

export const NAV_LINKS = [
  { label: "Products", href: "#products" },
  { label: "Solar O&M", href: "#om" },
  { label: "10-Year ROI Engine", href: "#roi" },
  { label: "Field Deployments", href: "#deployments" },
  { label: "FAQ", href: "#faq" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export const TRUST_METRICS = [
  { value: "0%", label: "Water Wastage", sub: "100% Dry & Hybrid Modes" },
  { value: "30%", label: "Recovered Gen. Gain", sub: "Up to, vs. soiled arrays" },
  { value: "12–20", label: "Month Payback", sub: "Typical plant feasibility" },
  { value: "150m", label: "Wireless Range", sub: "Long-range remote control" },
];

export const YANTR_2 = {
  fully: [
    ["Target", "Utility Ground-Mount Parks & C&I Rooftops"],
    ["Weight", "~30 kg — 30%+ lighter than industry avg"],
    ["Obstacle Clearance", "Spans >50 mm misalignment & inter-panel gaps"],
    ["Brush Mechanism", "1-min quick disassembly, downward wear adjust"],
    ["Power System", "Onboard self-charging PV + 12–24Ah battery"],
    ["Runtime", "4–6 hours continuous operation"],
    ["Array Lengths", "Single 1410–2804 / Double 2420–5208 / Triple 3430–7612 mm"],
    ["Speed / Power", "20–30 m/min · 100W–600W"],
    ["Smart Suite", "IoT Cloud telemetry, auto-scheduling, group mgmt, anti-fall"],
  ],
  semi: [
    ["Target", "Utility Ground-Mount Parks & C&I Rooftops"],
    ["Weight", "~30 kg — 30%+ lighter than industry avg"],
    ["Obstacle Clearance", "Spans >50 mm misalignment & inter-panel gaps"],
    ["Brush Mechanism", "1-min quick disassembly, downward wear adjust"],
    ["Power System", "Onboard self-charging PV + 12–24Ah battery"],
    ["Runtime", "4–6 hours continuous operation"],
    ["Array Lengths", "Single 1410–2804 / Double 2420–5208 / Triple 3430–7612 mm"],
    ["Speed / Power", "20–30 m/min · 100W–600W"],
    ["Control", "Manual operator start/stop — no cloud dependency"],
  ],
};

export const YANTR_3 = [
  ["Target", "Industrial Rooftops, Sheds & 3rd-Party O&M"],
  ["Chassis", "Continuous rubber crawler tracks, multi-directional"],
  ["Wireless Control", "150-meter long-range industrial remote"],
  ["Electrical", "24V working · 33.6V / 20Ah lithium · 130W motor"],
  ["Brush", "1100 mm length · 130 mm dia · 400–500 RPM PVC roller"],
  ["Speed Modes", "High 40 m/min · Low 25 m/min"],
  ["Efficiency", "0.8–1.2 MWp / day · ≤50 dB ultra-quiet"],
  ["Weight", "~40 kg"],
  ["Cleaning", "High-efficiency dry + front water nozzle (wet)"],
];

export const REVIEWS = [
  {
    quote:
      "Independent audits confirmed 99.5% dust removal efficiency across our array. Generation recovered almost immediately and the CapEx paid back in 20 months.",
    name: "Rajesh Menon",
    role: "Senior O&M Lead – Utility Solar EPC",
    img: "https://images.pexels.com/photos/3776969/pexels-photo-3776969.jpeg",
  },
  {
    quote:
      "Zero water usage was non-negotiable at our arid site. The robots crossed panel misalignment and inter-row gaps flawlessly — reliability we hadn't seen before.",
    name: "Ananya Desai",
    role: "Plant Operations Director – 25MW Ground Mount",
    img: "https://images.unsplash.com/photo-1672748341520-6a839e6c05bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBlbmdpbmVlciUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NzAzODM1M3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    quote:
      "The Yantr 3.0 crawler reaches sheds our teams couldn't safely access. Waterless cleaning slashed our operating costs and protected our rooftop yield year-round.",
    name: "Vikram Shah",
    role: "Industrial C&I Rooftop Owner",
    img: "https://images.pexels.com/photos/6961110/pexels-photo-6961110.jpeg",
  },
];

export const TRUST_BADGES = [
  { title: "IP65 / IP67 Ingress Protection", sub: "Sealed against dust, heat & water jets", icon: "shield" },
  { title: "IndiaMART TrustSEAL", sub: "Verified Exporter & Manufacturer", icon: "badge" },
  { title: "100% Waterless CleanTech", sub: "Zero water consumption", icon: "droplet" },
  { title: "Make in India / Startup India", sub: "Certified Manufacturer", icon: "flag" },
  { title: "GST Registered Entity", sub: "24AAGCH3472A1Z1", icon: "file" },
];

export const IMPACT = [
  { value: 50, suffix: "+ MWp", label: "Cumulative Solar Capacity Automated & Maintained" },
  { value: 10000, suffix: "+", label: "Autonomous Cleaning Cycles Completed" },
  { value: 12, suffix: "M+ L", label: "Industrial Water Saved to Date" },
  { value: 99.5, suffix: "%", label: "Average Dust & Soiling Elimination Efficiency", decimals: 1 },
];

// Replaceable YouTube video IDs — swap with real Helios field films anytime.
export const VIDEOS = [
  {
    id: "1kUE0BZtTRc",
    title: "Yantr 2.0 — Rooftop & Utility Ground-Mount Operations",
    tag: "Product Film",
    thumb: "https://images.unsplash.com/photo-1723133371535-1412bc2e412e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHw0fHxzb2xhciUyMHBhbmVsJTIwZmFybSUyMGFlcmlhbCUyMHV0aWxpdHklMjBzY2FsZXxlbnwwfHx8fDE3ODcwMzg0MzJ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "ScMzIvxBSi4",
    title: "Yantr 3.0 — Crawler All-Terrain Remote Cleaning",
    tag: "Product Film",
    thumb: "https://images.pexels.com/photos/14614266/pexels-photo-14614266.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "aqz-KE-bpKQ",
    title: "7 MWp Utility Solar Park — Aerial Drone Survey",
    tag: "Site Survey",
    thumb: "https://images.unsplash.com/photo-1594818379496-da1e345b0ded?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxzb2xhciUyMHBhbmVsJTIwZmFybSUyMGFlcmlhbCUyMHV0aWxpdHklMjBzY2FsZXxlbnwwfHx8fDE3ODcwMzg0MzJ8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const FAQS = [
  {
    q: "Does robotic dry cleaning cause micro-scratches on ARC solar glass?",
    a: "No. Our specialized microfiber and PVC roller brushes are engineered specifically for anti-reflective coated (ARC) photovoltaic glass, ensuring zero micro-abrasions or surface degradation over years of daily operation.",
  },
  {
    q: "How do Yantr robots handle inter-module expansion gaps and step misalignments?",
    a: "Yantr 2.0 incorporates active suspension and edge-sensing drive wheels capable of traversing step misalignments and gaps greater than 50 mm without jamming or skewing.",
  },
  {
    q: "How does remote cloud IoT scheduling operate in remote off-grid solar parks?",
    a: "Each automatic robot is equipped with a 4G/LTE cellular edge gateway and local memory. Schedules and task grouping execute autonomously even during temporary cellular dropouts, syncing back with the IoT dashboard once reconnected.",
  },
  {
    q: "What maintenance is required for the robots?",
    a: "Routine maintenance is minimal (~₹5,000/robot/year). The brush features a 1-minute quick disassembly with vertical downward adjustment to compensate for natural wear and double operational lifespan.",
  },
  {
    q: "Can the robots be deployed on high-tilt rooftop arrays?",
    a: "Yes. Yantr 3.0 uses continuous high-friction rubber crawler tracks designed specifically for pitched industrial sheds and rooftops with climbing capabilities up to 25°.",
  },
];

export const DEPLOYMENTS = [
  {
    img: "https://images.unsplash.com/photo-1723133371535-1412bc2e412e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHw0fHxzb2xhciUyMHBhbmVsJTIwZmFybSUyMGFlcmlhbCUyMHV0aWxpdHklMjBzY2FsZXxlbnwwfHx8fDE3ODcwMzg0MzJ8MA&ixlib=rb-4.1.0&q=85",
    tag: "Utility Park",
    title: "Ground-Mount · Multi-MW Array Traversal",
  },
  {
    img: "https://images.pexels.com/photos/14614266/pexels-photo-14614266.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tag: "C&I Rooftop",
    title: "Industrial Rooftop · Crawler Deployment",
  },
  {
    img: "https://images.unsplash.com/photo-1594818379496-da1e345b0ded?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxzb2xhciUyMHBhbmVsJTIwZmFybSUyMGFlcmlhbCUyMHV0aWxpdHklMjBzY2FsZXxlbnwwfHx8fDE3ODcwMzg0MzJ8MA&ixlib=rb-4.1.0&q=85",
    tag: "Utility Park",
    title: "Waterless Dry-Clean · Arid Region",
  },
  {
    img: "https://images.pexels.com/photos/6961112/pexels-photo-6961112.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tag: "O&M Audit",
    title: "Soiling Inspection & Telemetry Review",
  },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxzb2xhciUyMGZhcm0lMjBlbmdpbmVlcmluZ3xlbnwwfHx8fDE3ODcwMzgzNTR8MA&ixlib=rb-4.1.0&q=85",
  yantr2:
    "https://images.unsplash.com/photo-1629726797843-618688139f5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxzb2xhciUyMHBhbmVsJTIwZmFybSUyMGFlcmlhbCUyMHV0aWxpdHklMjBzY2FsZXxlbnwwfHx8fDE3ODcwMzg0MzJ8MA&ixlib=rb-4.1.0&q=85",
  yantr3:
    "https://images.unsplash.com/photo-1754619880959-2b0528375883?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVsJTIwY2xlYW5pbmclMjByb2JvdHxlbnwwfHx8fDE3ODcwMzg0MzJ8MA&ixlib=rb-4.1.0&q=85",
  om: "https://images.pexels.com/photos/6961110/pexels-photo-6961110.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
